import { render, staticRenderFns } from "./MatchResultsWidgetEfl.vue?vue&type=template&id=37a6a82e&scoped=true"
import script from "./MatchResultsWidgetEfl.vue?vue&type=script&lang=js"
export * from "./MatchResultsWidgetEfl.vue?vue&type=script&lang=js"
import style0 from "./MatchResultsWidgetEfl.vue?vue&type=style&index=0&id=37a6a82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6a82e",
  null
  
)

export default component.exports